import React from 'react';

/**
 * Template 10: Concept Illustration
 * Dark bg, composite/3D scene filling frame, serif headline bottom or center.
 *
 * Inspired by: "The Selfish Gene", "Working Hard Is Not Enough", "Infinite Paths"
 */
export default function V_ConceptIllustration({
  headline = 'The Selfish Gene',
  subjectImage,
  bgColor = '#0d1117',
  accentColor = '#00BCD4',
}) {
  return (
    <div style={{
      width: 1280, height: 720, position: 'relative', overflow: 'hidden',
      background: bgColor, fontFamily: "'Playfair Display', serif",
    }}>
      {/* Subject/concept image - fills most of frame */}
      {subjectImage ? (
        <div style={{
          position: 'absolute', inset: 0, zIndex: 1,
        }}>
          <img src={subjectImage} alt="" style={{
            width: '100%', height: '100%', objectFit: 'cover',
          }} />
          {/* Dark gradient from bottom for text readability */}
          <div style={{
            position: 'absolute', inset: 0,
            background: 'linear-gradient(0deg, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.3) 40%, rgba(0,0,0,0.1) 100%)',
          }} />
        </div>
      ) : (
        <div style={{
          position: 'absolute', inset: 40,
          background: `radial-gradient(circle at 50% 40%, ${accentColor}22 0%, transparent 60%)`,
          zIndex: 1,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 32, color: 'rgba(255,255,255,0.08)',
        }}>CONCEPT IMAGE</div>
      )}

      {/* Headline - bottom of frame */}
      <h1 style={{
        position: 'absolute', bottom: 50, left: 60, right: 60,
        margin: 0, fontSize: 96, fontWeight: 700, lineHeight: 1.05,
        color: '#FFFFFF', zIndex: 2,
        textShadow: '0 4px 24px rgba(0,0,0,0.9), 0 1px 2px rgba(0,0,0,0.5)',
      }}>
        {headline}
      </h1>
    </div>
  );
}
